var map = {
	"./de.json": "1506",
	"./en.json": "1360",
	"./es.json": "2941",
	"./fr.json": "8d07",
	"./it.json": "794c",
	"./nl.json": "d6b3",
	"./tr.json": "4e46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b67d";